import { CoreState } from '../../../models';
import { CORE_MUTATIONS_KEYS } from '../core.const';
import { CoreMutation } from '../core.interfaces';

export class SetOpenSortListMutation implements CoreMutation {
  mutations = {
    [CORE_MUTATIONS_KEYS.setOpenSortList]: (localState: CoreState, openState: boolean) => {
      localState.openSortList = openState;
    },
    [CORE_MUTATIONS_KEYS.toggleOpenSortList]: (localState: CoreState) => {
      localState.openSortList = !localState.openSortList;
    }
  };
}
